import type { ReactNode } from "react";
import React from "react";
import { Dropdown, EllipsisDropdownItem } from "@similarweb/ui-components";
import { itsMyOwnSegment } from "app/pages/segments/analysis/itsMyOwnSegment";
import {
    SegmentsEllipsisButton,
    StyledDropdownContainer,
} from "app/pages/segments/features/segments-homepage/StyledComponents";
import { getHasSegmentShareClaim } from "app/services/segments/SegmentsUtils";
import type { ICustomSegment } from "app/services/segments/segmentsApiService";
import { getIsSwUser } from "app/services/track/CustomUrlBuilderService";
import type { IActionItem } from "./utils";
import { getActionItems } from "./utils";

interface SegmentsAddtionalOptionsEllipsis {
    onClickDuplicate?: (row: any) => void;
    onClickEdit?: (row: any) => void;
    onClickDelete?: (row: any) => void;
    onToggleEllipsis?: (boolean) => void;
    row?: any;
    groupEllipsis?: boolean;
    onCopySegmentToUser?: (row: ICustomSegment) => void;
    onClickShare?: (row: ICustomSegment) => void;
    isLimitationExceeded?: boolean;
}

export const SegmentsStartTableAdditionalOptionsEllipsis = (props: SegmentsAddtionalOptionsEllipsis) => {
    const {
        onClickDuplicate,
        onClickEdit,
        onClickDelete,
        onToggleEllipsis,
        onClickShare,
        groupEllipsis,
        onCopySegmentToUser,
        row,
        isLimitationExceeded,
    } = props;
    function initialMenuContent() {
        return [<SegmentsEllipsisButton key="SegmentsEllipsisButton" />];
    }

    const isSegmentSharingEnabled = getHasSegmentShareClaim();

    const actionsList = React.useMemo(() => {
        let actionsMenu: (ReactNode | IActionItem)[] = initialMenuContent();
        if (row) {
            const actionItems = getActionItems(
                row,
                onClickEdit,
                onClickDuplicate,
                onClickShare,
                onCopySegmentToUser,
                onClickDelete,
                isLimitationExceeded,
            );
            const { edit, copyAndEdit, share, copyToUser, deleteObj } = actionItems;
            const hasSegmentShareClaimAndSwUser = isSegmentSharingEnabled && getIsSwUser();

            if (groupEllipsis) {
                actionsMenu = actionsMenu.concat([edit, deleteObj]);
            } else {
                let actionsArray: IActionItem[] = [];
                if (row?.segmentAdvancedDisabled) {
                    actionsArray = itsMyOwnSegment(row?.userId) ? [deleteObj] : [];
                } else if (itsMyOwnSegment(row?.userId)) {
                    if (hasSegmentShareClaimAndSwUser) {
                        actionsArray = [edit, copyAndEdit, share, copyToUser, deleteObj];
                    } else if (getIsSwUser()) {
                        actionsArray = [edit, copyAndEdit, copyToUser, deleteObj];
                    } else if (isSegmentSharingEnabled) {
                        actionsArray = [edit, copyAndEdit, share, deleteObj];
                    } else {
                        actionsArray = [edit, copyAndEdit, deleteObj];
                    }
                } else {
                    actionsArray = getIsSwUser() ? [copyAndEdit, copyToUser] : [copyAndEdit];
                }
                actionsMenu = actionsMenu.concat(actionsArray);
            }
        }
        return actionsMenu;
    }, [
        row,
        onClickEdit,
        onClickDuplicate,
        onClickShare,
        onCopySegmentToUser,
        onClickDelete,
        groupEllipsis,
        isLimitationExceeded,
        isSegmentSharingEnabled,
    ]);

    return actionsList.length > 1 ? (
        <StyledDropdownContainer>
            <Dropdown
                dropdownPopupPlacement="ontop-right"
                buttonWidth="40px"
                width="180px"
                itemsComponent={EllipsisDropdownItem}
                onClick={(action) => action.onClickFunc(action.id)}
                onToggle={onToggleEllipsis}
            >
                {actionsList}
            </Dropdown>
        </StyledDropdownContainer>
    ) : null;
};
